import type { ArticleResult } from '../../types';
const safe = (value: string | number | null | undefined, suffix = '') =>
  value == null || value === '' ? '暂无' : `${value}${suffix}`;
export function MetricsGrid({ article }: { article: ArticleResult }) {
  const rows = [
    ['评分等级', article.score_grade],
    ['AI 引用潜力', safe(article.ai_citation_potential_percent, '%')],
    ['收录概率估计', safe(article.inclusion_probability_percent, '%')],
    ['品牌曝光潜力', article.brand_exposure_potential],
    ['AI 置信度', safe(article.ai_confidence_percent, '%')],
    ['人工复核建议', article.human_review_recommendation],
    ['当前尝试次数', article.attempt_no]
  ];
  return (
    <div className="metrics-grid">
      {rows.map(([label, value]) => (
        <div className="metric" key={label}>
          <span>{label}</span>
          <strong>{safe(value)}</strong>
        </div>
      ))}
    </div>
  );
}
